import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { collectionLogoEndpoint } from '@/constants/urls';
import { states } from '@/constants/lifecycle';
import CollectionUploadLogo from '../components/CollectionUploadLogo';
import CollectionLogo from '../components/CollectionLogo';
import {
  checkCollectionImage,
  saveCollectionImage,
  saveCollectionImageError,
  saveCollectionImageSuccess,
  updateCollectionProperties,
} from '../actions';
import { collectionUppyId } from '../helper';
import { logoValidationParams } from '../constants';
import { collectionPermissions } from '../sharing/constants';

const CollectionImage = ({
  code,
  category,
  name,
  isNew,
  isEditing,
  canEdit,
  saveStatus,
  imageSaveStatus,
  imageAdded,
  imageKey,
  checkImage,
  saveImage,
  saveImageSuccess,
  saveImageError,
  uppyId,
  maxFileSize,
  allowedExtensions,
  narrowView,
}) => (
  <>
    {canEdit && (
    <CollectionUploadLogo
      allowedExtensions={allowedExtensions}
      category={category}
      checkImage={checkImage}
      code={code}
      imageAdded={imageAdded}
      isEditing={isEditing}
      isNew={isNew}
      maxFileSize={maxFileSize}
      saveImage={saveImage}
      saveImageError={saveImageError}
      saveImageSuccess={saveImageSuccess}
      saveStatus={saveStatus}
      uppyId={uppyId}
    />
    )}
    {!isEditing && (
    <CollectionLogo
      imageKey={imageKey}
      altText={name}
      isSaving={imageSaveStatus === states.PENDING}
      src={collectionLogoEndpoint(code)}
      {...(!narrowView && { floated: 'left' })}
    />
    )}
  </>
);

const withoutItem = (logoValidation) => (
  {
    isEditing: false,
    isNew: false,
    name: '',
    previousCode: null,
    saveStatus: states.NONE,
    imageSaveStatus: states.NONE,
    canEdit: false,
    uppyId: null,
    maxFileSize: logoValidation.max_file_size,
    allowedExtensions: logoValidation.file_extensions,
  }
);

const withItem = (item, role, logoValidation) => (
  {
    isEditing: item.isEditing,
    isNew: item.isNew,
    name: item.name,
    previousCode: item.previousCode,
    saveStatus: item.saveStatus,
    imageSaveStatus: item.imageSaveStatus,
    imageKey: item.imageKey,
    canEdit: role.permissions.collections.update || item.permissions[collectionPermissions.UPDATE],
    uppyId: item ? collectionUppyId(item) : null,
    maxFileSize: logoValidation.max_file_size,
    allowedExtensions: logoValidation.file_extensions,
  }
);

const mapStateToProps = ({
  auth: { role },
  collections: { collections },
}, { category, code }) => {
  const item = findResult(collections, category, code);
  return item ? withItem(item, role, logoValidationParams) : withoutItem(logoValidationParams);
};

const mapDispatchToProps = {
  imageAdded: (category, code, value) => updateCollectionProperties(category, code, { imageAdded: value }),
  checkImage: checkCollectionImage,
  saveImage: saveCollectionImage,
  saveImageSuccess: saveCollectionImageSuccess,
  saveImageError: saveCollectionImageError,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionImage);
